import React from 'react';
import { Message } from '../types';
import { formatTime } from '../utils/formatTime';
import { CircleUser as UserCircle, ExternalLink } from 'lucide-react';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isBot = message.type === 'bot';
  
  const extractLink = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.match(urlRegex)?.[0];
  };

  const handleLinkClick = () => {
    if (message.originalResponse) {
      const link = extractLink(message.originalResponse);
      if (link) {
        window.open(link, '_blank');
      }
    }
  };
  
  return (
    <div className={`flex mb-6 ${isBot ? 'justify-start' : 'justify-end'}`}>
      {isBot && (
        <div className="flex-shrink-0 mr-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-red-600 to-red-500 flex items-center justify-center text-white shadow-lg">
            <span className="text-sm font-bold">GB</span>
          </div>
        </div>
      )}
      
      <div className={`max-w-[80%] ${
        isBot 
          ? 'bg-white text-gray-800 rounded-2xl rounded-tl-md shadow-md border border-red-100'
          : 'bg-gradient-to-r from-red-500 to-red-600 text-white rounded-2xl rounded-tr-md shadow-lg'
      } p-4`}>
        <p className={`leading-relaxed ${isBot ? 'text-base' : 'text-sm'}`}>{message.text}</p>
        
        {message.hasLink && (
          <button
            onClick={handleLinkClick}
            className="mt-3 flex items-center text-red-600 hover:text-red-700 bg-red-50 hover:bg-red-100 px-3 py-2 rounded-lg transition-colors text-sm font-medium"
          >
            <ExternalLink className="h-4 w-4 mr-2" />
            Detaylar için Tıklayın
          </button>
        )}
        
        <p className={`text-xs mt-2 ${isBot ? 'text-gray-500' : 'text-red-100'}`}>
          {formatTime(message.timestamp)}
        </p>
      </div>
      
      {!isBot && (
        <div className="flex-shrink-0 ml-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center text-white shadow-lg">
            <UserCircle className="h-6 w-6" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatMessage;